export default {
      id: "shipments-package-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "img/icons.svg#shipments-package",
      toString: function () {
        return this.url;
      }
    }